<template>
  <div class="video-container">
    <iframe :src="`https://www.youtube.com/embed/${videoUrl}?autoplay=1&mute=1&loop=1&modestbranding=0&showinfo=1`"
      frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope;" allowfullscreen></iframe>
  </div>
</template>
<script>
export default {
  name: "Video",
  props: ["videoUrl", "videoMobile"],
  data() {
    return {
      currentVideo: '',
      player: null,
      showSound: false,
      muted: false,
      isYoutube: this.videoUrl.includes("youtube"),
      isIphone: navigator.userAgent.match(/iPhone/i) ? true : false
    }
  },
  methods: {
    handleOrientationChange() {
    },
    sonido() {
      if (this.muted) {
        this.player.setVolume(100);
      } else {
        this.player.setVolume(0);
      }
      this.muted = !this.muted;
    },
    sonidoOff() {
      this.muted = true;
      this.showSound = true;
    },
    sonidoOn() {
      this.muted = false;
      this.showSound = true;
    },
    playerplay() {
      this.player.videoPlay()
    },
    playerstop() {
      this.player.videoStop()
    },
  },
  mounted() {
    this.handleOrientationChange();
    window.addEventListener(
      "orientationchange",
      this.handleOrientationChange
    );
    const self = this;
    const initSound = function (volume) {
      console.log("Volume was " + volume);
      if (volume == 0) {
        self.sonidoOff();
      } else {
        self.sonidoOn();
      }
    }


    window.scrollTo(0, 0);
  },
};
</script>

<style lang="scss" scoped>
.video-container {
  position: relative;
  padding-bottom: 56.25%;
}

.video-container iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>
